// Default-namespace keys used by the COMO hand-off UI; every shipped locale must define all of them.
export const COMO_ERROR_KEYS: { [code: string]: string } = {
  RATE_LIMITED: 'comoHandOffErrorRateLimited',
  FORBIDDEN: 'comoHandOffErrorDenied',
  NOT_LINKED: 'comoHandOffErrorNotLinked',
  REMOTE_DENIED: 'comoHandOffErrorRemoteDenied',
  UNAVAILABLE: 'comoHandOffErrorUnavailable',
  // Link states known before any hand-off attempt.
  LINK_PENDING: 'comoLinkPending',
  LINK_FAILED: 'comoLinkFailed',
  STATE_ERROR: 'comoStateError'
};

export const COMO_TRANSLATION_KEYS: string[] = [
  'comoHandOffLoading',
  'comoHandOffTitle',
  'comoHandOffOpen',
  'comoHandOffRetry',
  'comoStateErrorTitle',
  'comoLinkCheckAgain',
  ...Object.values(COMO_ERROR_KEYS)
];
